import { render, staticRenderFns } from "./HSCodeList.vue?vue&type=template&id=6afb49ee&scoped=true"
import script from "./HSCodeList.vue?vue&type=script&lang=js"
export * from "./HSCodeList.vue?vue&type=script&lang=js"
import style0 from "./HSCodeList.vue?vue&type=style&index=0&id=6afb49ee&prod&lang=scss&scoped=true"
import style1 from "./HSCodeList.vue?vue&type=style&index=1&id=6afb49ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb49ee",
  null
  
)

export default component.exports